<svg xmlns="http://www.w3.org/2000/svg" width="16.8" height="17.6" viewBox="0 0 16.8 17.6">
  <g fill="currentColor">
    <path d="M2.3,6.2A1.278,1.278,0,0,0,1.1,7.3L0,16.3c0,.3,0,.7.3.9a1.086,1.086,0,0,0,.9.4H15.6a1.086,1.086,0,0,0,.9-.4,1.613,1.613,0,0,0,.3-.9l-1.1-9a1.2,1.2,0,0,0-1.2-1.1H2.3M14.5,7.4l1.1,9H1.2l1.1-9H14.5Z"/>
    <path d="M9.6,4.2,9,6.2h1.3l.5-1.7A1.245,1.245,0,0,0,10,3L5.2,1.5a1.245,1.245,0,0,0-1.5.8L2.5,6.2H3.8L4.9,2.7Z"/>
    <path d="M11.96,9.149a3.56,3.56,0,0,1-7.12,0,.594.594,0,0,1,1.187,0,2.373,2.373,0,1,0,4.746,0,.594.594,0,0,1,1.187,0"/>
    <path d="M8.2,1.2h5v5h1.2v-5A1.155,1.155,0,0,0,13.2,0h-5A1.155,1.155,0,0,0,7,1.2v.863l1.2.375V1.2"/>
  </g>
</svg>